var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cx from 'classnames';
import Image from '../Image';
import { SkeletonImage } from '../Skeleton';
import Initials from './Initials';
export default class Avatar extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            error: false,
            isLoaded: false,
            source: '',
        };
        this.setError = () => this.setState({ error: true });
        this.setHasLoaded = () => this.setState({ isLoaded: true });
    }
    static getDerivedStateFromProps({ src }, state) {
        if (src !== state.source) {
            return {
                error: false,
                isLoaded: false,
                source: src,
            };
        }
        return null;
    }
    render() {
        const _a = this.props, { placeholder, fallbackSource, name, src } = _a, initialsProps = __rest(_a, ["placeholder", "fallbackSource", "name", "src"]);
        const { className, size, circular } = initialsProps;
        const { source, error, isLoaded } = this.state;
        const failedToLoad = error || !source;
        const showPlaceholder = placeholder && !isLoaded && !failedToLoad;
        if (failedToLoad) {
            if (name !== undefined) {
                return React.createElement(Initials, Object.assign({ name: name }, initialsProps));
            }
            if (!fallbackSource) {
                return React.createElement(SkeletonImage, { size: size, circular: circular, animated: false });
            }
        }
        return (React.createElement(React.Fragment, null,
            showPlaceholder && React.createElement(SkeletonImage, { size: size, circular: circular }),
            React.createElement(Image, Object.assign({ rounded: true }, initialsProps, { className: cx(className, { hidden: showPlaceholder }), onError: this.setError, onLoad: this.setHasLoaded, src: failedToLoad ? fallbackSource : source }))));
    }
}
Avatar.defaultProps = {
    placeholder: true,
    size: 'medium',
    fallbackSource: null,
    circular: false,
};
//# sourceMappingURL=Avatar.js.map